"use strict";
/*!
 * InlineEdit for DataTables
 * Inspired by https://github.com/Brizhanev/datatables-quickedit
 *
 * How to use :
 *  Datatable settings :
      inlineEdit: {
        enabled: true
      }
    
    On editable cells :
      data-editable="true"     // Enable inline edit on this cell
      data-name="FIELD_NAME"   // Field name
      data-value="VALUE"       // Original value
      data-text="VALUE"        // Original view (may be different from value, for select2 for example)
      data-data-type="FIELD_TYPE"  // Field type (string, number or select2)
      data-submit-route="@Url.Action("Edit", "Roles")" // Route to submit the object to
      data-submit-data="@JsonConvert.SerializeObject(new { item.Id })" // Additional data to submit the object
      data-url=""              // The Select2 data source route

    If the route requires a CSRF token, add this to any parent of the editable cells :
      data-submit-csrf-token="@Xsrf.GetAndStoreTokens(Context).RequestToken"

    ... with this injection:
      @inject Microsoft.AspNetCore.Antiforgery.IAntiforgery Xsrf
 */

Object.defineProperty(exports, "__esModule", { value: true });
var InlineEditDataType_1 = require("./InlineEditDataType");
var dataTable = $.fn.dataTable;
var dataTypes = [new InlineEditDataType_1.InlineEditString(), new InlineEditDataType_1.InlineEditNumber(), new InlineEditDataType_1.InlineEditBoolean(), new InlineEditDataType_1.InlineEditSelect2()];
dataTable.defaults.inlineEdit = {
    enabled: false,
    selector: "td[data-editable=true]",
    cancelButtonSelector: ".dt-cancel-edit",
    startEdit: function startEdit(cell, table) {
        var $cell = $(cell);
        if ($cell.hasClass("dt-editing")) {
            return;
        }
        var dataType = $cell.data("dataType");
        var value = $cell.data("value") || "";
        $cell.data("originalContent", $cell.html());
        var types = dataTypes.filter(function (_) {
            return _.name === dataType;
        });
        if (types.length === 0) {
            return;
        }
        var type = types[0];
        $cell.data("typeObject", type);
        var input = type.formatInput(cell, value);
        $cell.addClass("dt-editing");
        $cell.find(".dt-focus").select();
        var form = "<div class=\"form-inline\">\n                            <div class=\"input-group w-100\">\n                                " + input + "\n                                <div class=\"input-group-append\">\n                                    <button class=\"btn btn-sm btn-primary input-group-text px-2 dt-submit\"><i class=\"fa fa-save\"></i></button>\n                                </div>\n                                <div class=\"input-group-append\">\n                                    <button class=\"btn btn-sm btn-secondary input-group-text px-2 dt-cancel-edit\" type=\"button\"><i class=\"fa fa-times\"></i></button>\n                                </div>\n                            </div>\n                        </div>";
        // Set cell HTML
        $cell.html(form);
        // Register events
        $cell.find(".dt-submit").click(function (e) {
            e.stopImmediatePropagation();
            $(this).trigger("dt.endEdit");
        });
        $cell.find("> div").click(function (e) {
            e.stopImmediatePropagation();
        });
        $cell.find(".dt-cancel-edit").click(function (e) {
            e.stopImmediatePropagation();
            $(this).trigger("dt.cancelEdit");
        });
        type.postProcessInput(cell);
    },
    endEdit: function endEdit(cell, table) {
        var $cell = $(cell);
        $cell.removeClass("dt-editing");
        var type = $cell.data("typeObject");
        var $input = $cell.find(".dt-input");
        var value = type.formatValue(cell, $input.val());
        var endEditCustom = $cell.data("end-edit-fn");
        if (endEditCustom) {
            if ($cell.data("save-value-before")) {
                this.saveValue(cell);
            }
            $[endEditCustom](this, cell, value);
        } else {
            this.saveValue(cell);
        }
    },
    saveValue: function saveValue(cell) {
        var $cell = $(cell);
        var submitRoute = $cell.data("submitRoute");
        var submitData = $cell.data("submitData") || {};
        var $input = $cell.find(".dt-input");
        var type = $cell.data("typeObject");
        var value = type.formatValue(cell, $input.val());
        var name = $cell.data("name");
        submitData[name] = value;
        var csrf = $cell.parents("[data-submit-csrf-token]").data("submitCsrfToken");
        if (csrf) {
            submitData["__RequestVerificationToken"] = csrf;
        }
        $.ajax(submitRoute, {
            data: submitData,
            method: "post"
        }).done(function () {
            $cell.html(type.formatView(cell, value));
            $cell.data("value", value);
            $cell.trigger("dt.edited", value);
        });
    },
    cancelEdit: function cancelEdit(cell, table) {
        var $cell = $(cell);
        $cell.removeClass("dt-editing");
        $cell.html($cell.data("originalContent"));
    }
};
var inlineEdit = {
    init: function init(dt) {
        var ctx = dt.settings()[0];
        var init = ctx.oInit.inlineEdit;
        var opts = $.extend(dataTable.defaults.inlineEdit, init);
        if (!opts.enabled) {
            return;
        }
        dt.iterator("table", function () {
            var table = this;
            this.on("dblclick", opts.selector, function (e) {
                e.stopImmediatePropagation();
                opts.startEdit(this, table);
            });
            this.on("keyup", opts.selector, function (event) {
                if (event.which == 13) {
                    opts.endEdit(this, table);
                }
            });
            this.on("dt.endEdit", opts.selector, function () {
                opts.endEdit(this, table);
            });
            this.on("dt.cancelEdit", opts.selector, function () {
                opts.cancelEdit(this, table);
            });
        });
    }
};
dataTable.Api.register("inlineEdit()", function () {
    return this.iterator("table", function (ctx) {
        inlineEdit.init(new dataTable.Api(ctx));
    });
});
$(document).on("preInit.dt.dtInlineEdit", function (e, ctx) {
    if (e.namespace !== "dt") {
        return;
    }
    inlineEdit.init(new dataTable.Api(ctx));
});
dataTable.inlineEdit = inlineEdit;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Datatable/datatables.inlineEdit.ts
// module id = 523
// module chunks = 0